import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught an error", error, errorInfo);
    
    // Auto-reload once if it's a chunk load error
    if (error && error.message && (error.message.includes('Failed to fetch dynamically imported module') || error.message.includes('Importing a module script failed'))) {
      if (!sessionStorage.getItem('chunk_failed')) {
        sessionStorage.setItem('chunk_failed', 'true');
        window.location.reload();
        return;
      }
    }
    
    this.setState({ errorInfo });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '2rem', background: 'rgba(239, 68, 68, 0.1)', border: '1px solid #ef4444', borderRadius: '12px', margin: '1rem', color: 'white' }}>
          <h2 style={{ color: '#ef4444', marginTop: 0 }}>🚨 Error detectado en el renderizado</h2>
          <p>La aplicación ha fallado al intentar dibujar este componente. Por favor, copia el siguiente error y compártelo:</p>
          <pre style={{ background: '#0f172a', padding: '1rem', borderRadius: '8px', overflowX: 'auto', fontSize: '0.8rem', color: '#f8fafc' }}>
            {this.state.error && this.state.error.toString()}
            <br />
            {this.state.errorInfo && this.state.errorInfo.componentStack}
          </pre>
          <button 
            onClick={() => window.location.reload()} 
            style={{ marginTop: '1rem', padding: '0.75rem 1.5rem', background: '#ef4444', color: 'white', border: 'none', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer', width: '100%' }}>
            Recargar Aplicación
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
